import React, {Component} from 'react';
import {client} from '../../Client';
import 'react-date-picker/index.css'
import LocalTime from '../LocalTime'
import AttivitaProgress from './AttivitaProgress'
import ModalConfirm from '../ModalConfirm'
import {minutesToHuman} from '../../Helpers'
import PropTypes from 'prop-types';

class AttivitaCompletate extends Component {
    constructor(props) {
        super(props);
        this.state = {
            cfg:client.getConfigurazione(),
            pieData:{},
        };
        this.onMenuChange = this.onMenuChange.bind(this);
    }

    componentWillReceiveProps(nextProps){
    }

    onMenuChange(menu, attivita, attivitaPrec, attivitaSucc){
        if (menu === 'edit')
        {
            if (this.props.onEditAttivita) {
                this.props.onEditAttivita(attivita, attivitaPrec, attivitaSucc)
            }
        } else if (menu === 'sovrapponi')
        {
            if (this.props.onSovrapponiAttivita) {
                this.props.onSovrapponiAttivita(attivita, attivitaPrec, attivitaSucc)
            }
        } else if (menu === 'nuova')
        {
            if (this.props.onNuovaAttivita) {
                this.props.onNuovaAttivita(attivita)
            }
        } else if (menu === 'riattiva')
        {
            if (this.props.onRiattivaAttivita) {
                this.props.onRiattivaAttivita(attivita)
            }
        }
    }

    createPieData(items)
    {
        let labels = [];
        let datas = [];
        let colors = [];
        for(let i=0; i<items.length; i++){

            labels.push(items[i].nomeBreve + " durata " + minutesToHuman(items[i].durataPesata));
            datas.push(items[i].durataPesata);
            colors.push(items[i].idCommessa.colore)
        }

        const data = {
            labels: labels,
            datasets: [{
                data: datas,
                backgroundColor: colors,
                hoverBackgroundColor: colors,
            }]
        };
        return data;
    }


    render() {

        let minutiTotali = 0;
        for(let i=0; i<this.props.items.length; i++){
            minutiTotali += this.props.items[i].durataPesata;
        }
        let durataStd = this.state.cfg && this.state.cfg.oreGiornaliere ? this.state.cfg.oreGiornaliere*60 : 500;

        let percCompletamento = ((minutiTotali / durataStd)*100).toFixed(1);
        let progress = <AttivitaProgress percCompletamento={percCompletamento} />;
        if (this.props.showProgress === false){
            progress = null;
        }

        let orderedItems = this.props.items.slice();
        orderedItems.sort((a,b) => {
            if (a.inizio < b.inizio){
                return 1;
            }
            else if (a.inizio > b.inizio){
                return -11;
            }
            else{
                return 0;
            }
        });
        let oraInizioUltimaAttivita = undefined;
        let attivitaList =  orderedItems.map((item, index, arr) => {

            if (oraInizioUltimaAttivita === undefined){
                oraInizioUltimaAttivita = item.inizio;
            }
            let attivitaPrec = undefined;
            let attivitaSucc = undefined;

            // Il pulsante delete viene messo sempre.
            // Se va messo solo sull'ultima attività scommenatre questo if:
            //if (index === this.props.items.length - 1){
            // let deleteMenuButton = (<ModalConfirm
            //     msg={"Stai per cancellare l'attività seguente: " + item.nomeCompleto}
            //     onClickOk={(ev) => (this.props.onDeleteClick(ev, item))}
            // >
            //     <Dropdown.Item key="delete" icon='trash' text='Elimina' />
            // </ModalConfirm>)
            let deleteButton = null;
            if (this.props.onDeleteClick){
                deleteButton = (<ModalConfirm
                    msg={"Stai per cancellare l'attività seguente: " + item.nomeCompleto}
                    onClickOk={(ev) => (this.props.onDeleteClick(ev, item))}
                >
                    <a className="ui pointer mini red icon button"><i className="trash icon"></i></a>
                </ModalConfirm>)
            }
            let nuovaAttivitaButton = null;
            if (this.props.onNuovaAttivita){
                if (this.props.attivitaRunning){
                    nuovaAttivitaButton = (
                        <a title="Avvia nuova attività simile a questa" href="#" className="ui pointer mini disabled icon button"><i className="copy icon"></i></a>
                    )
                }
                else {
                    nuovaAttivitaButton = (
                        <a title="Avvia nuova attività simile a questa" href="#" className="ui pointer mini primary icon button" onClick={(ev, dt) => this.onMenuChange('nuova', item, attivitaPrec, attivitaSucc, ev, dt)}><i className="copy icon"></i></a>
                    )
                }
            }

            let riattivaAttivitaButton = null;
            if(this.props.onRiattivaAttivita){
                if (this.props.attivitaRunning || oraInizioUltimaAttivita !== item.inizio){
                    riattivaAttivitaButton = (
                        <a title="Riattiva questa attività" href="#" className="ui pointer mini disabled icon button"><i className="undo icon"></i></a>
                    )
                }
                else {
                    riattivaAttivitaButton = (
                        <a title="Riattiva questa attività" href="#" className="ui pointer mini primary icon button" onClick={(ev, dt) => this.onMenuChange('riattiva', item, attivitaPrec, attivitaSucc, ev, dt)}><i className="undo icon"></i></a>
                    )
                }
            }

            let creaAttivitaSovrappostaButton = null;
            if(this.props.onSovrapponiAttivita){
                creaAttivitaSovrappostaButton = (
                    <a title="Crea attività sovrapposta" href="#" className="ui pointer mini primary icon button" onClick={(ev, dt) => this.onMenuChange('sovrapponi', item, attivitaPrec, attivitaSucc, ev, dt)}><i className="object ungroup icon"></i></a>
                )
            }

            let modificaAttivitaButton = null;
            if(this.props.onEditAttivita){
                modificaAttivitaButton = (
                    <a title="Modifica questa attività" className="ui pointer mini primary icon button" onClick={(ev, dt) => this.onMenuChange('edit', item, attivitaPrec, attivitaSucc, ev, dt)}><i className="edit icon"></i></a>
                )
            }

            if (index > 0){
                attivitaSucc = arr[index-1];
            }
            if (index < arr.length-1){
                attivitaPrec = arr[index+1];
            }

            return (<tr key={item.idAttivita}>
                    <td >
                        {/*<Dropdown icon='setting' compact floating button className='icon tiny left' >*/}
                            {/*<Dropdown.Menu>*/}
                                {/*<Dropdown.Header icon='tags' content='Cosa fare con questa attività...' />*/}
                                {/*<Dropdown.Divider />*/}
                                {/*<Dropdown.Item key="copy" icon='copy' text='Crea attività sovrapposta' onClick={(ev, dt) => this.onMenuChange('sovrapponi', item, attivitaPrec, attivitaSucc, ev, dt)}/>*/}
                                {/*<Dropdown.Item key="edit" icon='edit' text='Modifica' onClick={(ev, dt) => this.onMenuChange('edit', item, attivitaPrec, attivitaSucc, ev, dt)}/>*/}
                                {/*<Dropdown.Divider />*/}
                                {/*{deleteMenuButton}*/}
                            {/*</Dropdown.Menu>*/}
                        {/*</Dropdown>*/}

                        <label className="ui empty circular label" style={{backgroundColor: item.idCommessa.colore}}></label> {item.idCommessa.nomeCompleto}
                        <div className="content">
                            <i>{item.nota}</i>
                        </div>
                    </td>
                    <td className="collapsing center aligned">
                        <a href="#" onClick={()=>this.props.onOrarioClick(item.inizio)} title="Clicca per impostare questo orario come inizio/fine attività">
                            <LocalTime data={item.inizio} />
                        </a>
                    </td>
                    <td className="collapsing center aligned">
                        <a href="#" onClick={()=>this.props.onOrarioClick(item.fine)} title="Clicca per impostare questo orario come inizio/fine attività">
                            <LocalTime data={item.fine} />
                        </a>
                    </td>
                    <td className="collapsing right aligned" title="durata in ore:minuti">
                        {minutesToHuman(item.durataPesata)}
                    </td>
                    <td className="collapsing right aligned" title="peso attività (n/d)">
                        {item.peson + "/" + item.pesod}
                    </td>
                    {/*<td className="collapsing right aligned" title="% attività sulla giornata">*/}
                        {/*<ShowLocalNumber value={item.durataPesata / minutiTotali} type="percent"/>*/}
                    {/*</td>*/}
                    <td className="collapsing right aligned" >
                        {riattivaAttivitaButton}
                        {nuovaAttivitaButton}
                        {creaAttivitaSovrappostaButton}
                        {modificaAttivitaButton}
                    </td>
                    <td className="collapsing right aligned" title="Elimina">
                        {deleteButton}
                    </td>
                </tr>
            )
        });

        let loader = '';
        if  (this.props.loading) {
            loader = (
                <div className="ui active inverted dimmer">
                    <div className="ui loader"></div>
                </div>
            );
        }

        if (this.props.items.length <= 0){
            attivitaList = <h3>Nessuna attività ancora registrata</h3>
        }
        else {
            attivitaList = <table className="ui table">
                <tbody>
                {attivitaList}
                </tbody>
                <tfoot>
                <tr>
                    <th colSpan={8}>
                        Tempo totale registrato oggi: <b>{minutesToHuman(minutiTotali)}</b> (<b>{minutiTotali}</b>  minuti)

                        {progress}


                    </th>
                </tr>
                </tfoot>
            </table>;
        }

        return (
            <div className="ui segment">
                <div className="ep-outer-table">
                    <div className="ep-inner-scrollable-table">

                    {attivitaList}

                    </div>
                </div>
                {loader}
            </div>

        )
    }
}

AttivitaCompletate.PropTypes = {
    items: PropTypes.array.isRequired,
    giorno: PropTypes.string.isRequired,
    onEditAttivita: PropTypes.func.isRequired,
    onSovrapponiAttivita: PropTypes.func.isRequired,
    onNuovaAttivita: PropTypes.func.isRequired,
    onOrarioClick: PropTypes.func.isRequired,
    loading: PropTypes.bool,
    showProgress: PropTypes.bool,
    attivitaRunning: PropTypes.bool.isRequired,
}

AttivitaCompletate.defaultProps = {
    loading: true,
    showProgress: true,
}

export default AttivitaCompletate;




/** WEBPACK FOOTER **
 ** ./src/components/attivita/AttivitaCompletate.jsx
 **/